import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/experiments")({
  component: () => (
    <Breadcrumb label="Experiments" to="/experiments">
      <Outlet />
    </Breadcrumb>
  ),
});
